import React from 'react'

import { IMedkitComponent } from '..'

import { appDownloadButtonTheme } from './theme'
import styles from './index.module.scss'
import AppStoreSVG from './appstore.svg'
import PlayStoreSVG from './playstore.svg'

type vendor = 'AppStore' | 'PlayStore'

export interface AppDownloadButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  onClick?: () => void
  title: string
  vendor: vendor
}

function getVendorImage(vendor: vendor): string {
  switch (vendor) {
    case 'AppStore':
      return AppStoreSVG
    case 'PlayStore':
      return PlayStoreSVG
    default:
      return ''
  }
}

const AppDownloadButton: IMedkitComponent<
  AppDownloadButtonProps,
  typeof appDownloadButtonTheme
> = ({ href, onClick, title, vendor }) => (
  <a
    className={styles.AppDownloadButton}
    href={href}
    title={title}
    onClick={onClick}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      className={styles.AppDownloadSVG}
      src={getVendorImage(vendor)}
      alt={title}
    />
  </a>
)

AppDownloadButton.theme = appDownloadButtonTheme

export default AppDownloadButton
